import Mediator from 'common/scripts/mediator';
import Utils from 'common/scripts/utils';

const mediator = new Mediator();

class Contacts {
    constructor(options) {
        this.wrapper = options.wrapper;
        this.list = this.wrapper.querySelector('.j-contacts-list');
        this.officeItems = this.list.querySelectorAll('.j-contacts-office');
        this.mapWrapper = this.wrapper.querySelector('.j-mapbox');
        this.closeMapPopup = this.mapWrapper.querySelector('.j-close-map');
        this.map = null;
        this.markers = null;
        this.activeClass = 'is-active';
        this.externalLink = this.wrapper.querySelector('.j-contacts-external') || null;
        this.isMobile = Utils.isBreakpoint(0, 670);
    }

    init() {
        this._bindEvents();

        if (this.officeItems.length) {
            this.officeItems.forEach((item) => {
                this._initOfficeCard(item);
            });
        }
    }

    _bindEvents() {
        mediator.subscribe('markersReady', (map, markers) => {
            this.map = map;
            this.markers = markers;
            this._setMapBounds();
        });

        mediator.subscribe('markerClick', (marker) => {
            this._setActiveCard(marker);
        });

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this._setMapBounds.bind(this));
            this.isMobile = Utils.isBreakpoint(0, 670);
        });

        this.closeMapPopup.addEventListener('click', () => {
            this.mapWrapper.classList.remove(this.activeClass);
        });
    }

    _setMapBounds() {
        const currentBounds = this.map.getBounds();
        const paddingLeft = this.list.offsetWidth;
        const wrapper = this.map._container.closest('.j-contacts');

        if (paddingLeft && wrapper.offsetHeight) {
            this.map.fitBounds(currentBounds, {
                padding: {
                    top   : 0,
                    bottom: 0,
                    left  : window.screen.availWidth >= 670 ? paddingLeft : 0,
                    right : 0
                }
            });
        }
    }

    _initOfficeCard(card) {
        const showMap = card.querySelector('.j-contacts-showmap');
        const coords = card.dataset.coords ? card.dataset.coords.split(',').map(Number) : null;

        card.addEventListener('click', (event) => {
            const isShowBtn = event.target.closest('.j-contacts-item-more');

            if (card.classList.contains(this.activeClass) && !isShowBtn) {
                return;
            }

            const method = isShowBtn && card.classList.contains(this.activeClass) ? 'remove' : 'add';

            this.officeItems.forEach((item) => {
                item.classList.remove(this.activeClass);
            });
            card.classList[method](this.activeClass);
            this.externalLink.setAttribute('href', card.dataset.link);
            if (coords) {
                const margin = Number(window.getComputedStyle(this.list).getPropertyValue('margin-left')
                    .replace('px', ''));
                const offsetX = this.isMobile ? 0 : (this.list.offsetWidth + margin) / 2;

                if (Math.ceil(this.map.getZoom()) === 14) {
                    this.map.panTo(coords, {offset: [offsetX, 0]});
                } else {
                    this.map.zoomTo(14);
                    setTimeout(() => {
                        this.map.panTo(coords, {offset: [offsetX, 0]});
                    }, 300);
                }
                this.markers.forEach((item) => {
                    const methodMarker = item.dataset.id === card.dataset.id ? 'add' : 'remove';

                    item.classList[methodMarker](this.activeClass);
                });
            }
        });

        showMap.addEventListener('click', () => {
            this.mapWrapper.classList.add(this.activeClass);
            this.map.resize();
        });
    }

    _setActiveCard(marker) {
        const markerId = marker.dataset.id;

        this.officeItems.forEach((card) => {
            if (card.dataset.id === markerId) {
                const showBtn = card.querySelector('.j-contacts-item-more');
                const cardsWrapper = card.parentElement;

                if (!card.classList.contains(this.activeClass)) {
                    showBtn.click();
                }

                cardsWrapper.scrollTo({
                    top     : card.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }
}

export default Contacts;
